import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';
import GridConfig from "./GridConfig";

export default class UserlogReport extends Base {
	constructor(props) {
		super(props);
		this.state = {
			data: null,
			loading: true,
            configName: 'userlog_report',
		}
	}
	componentDidMount() {
		this.httpPost("api/v1/report/userlog")
			.then(data => {
				if (data.status === -1) window.location.href = "/login";
				if (data.status === 1) {
					this.setState({
						data: data,
						loading: false
					})
				}
				else {
					this.showErorrMessage(data.message);
					this.setState({
						loading: false
					});
				}
			});
	}
	onGridConfig() {
		this.showComponents({ component: <GridConfig Caller={this} Config={this.getGridConfig()} /> });
	}
	getDefaultConfig() {
		return {
			name: this.state.configName,
			fields: [
				{ field: "userName", caption: "نام کاربر", show: true },
				{ field: "typeStr", caption: "عملیات", show: true },
				{ field: "description", caption: "شرح", show: true },
				{ field: "date", caption: "تاریخ", show: true },
			]
		}
	}
	getColumns() {
		var config = this.getGridConfig();
		var t = [];
		config.fields.forEach(f => {
			if (f.field == 'userName' && f.show) t.push({ field: f.field, headerName: f.caption });
			if (f.field == 'typeStr' && f.show) t.push({ field: f.field, headerName: f.caption });
			if (f.field == 'description' && f.show) t.push({ field: f.field, headerName: f.caption });
			if (f.field == 'date' && f.show) t.push({ field: f.field, headerName: f.caption });
		});
		return t;
	}
	renderForm() {
		return <div className="container"> <div className="row">
			<div className="col-sm-12">
				<div className="panel panel-info">
					<div className="panel-body">
						<div className="col-sm-3">
							لاگ کاربران
						</div>
						<div className="col-sm-6 text-center" style={{ "display": "flex", "place-content": "center" }}>
						</div>
						<div className="col-sm-3 text-left">
							<a className="btn btn-no-frame btn-smoke btn-sm pull-left" onClick={e => this.onGridConfig()} title="تنظیمات نمایش">
								<span className="fa fa-cog"></span>
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>
			{this.renderAgGrid({
				columnDefs: this.getColumns()
			})}
		</div>
	}
	render() {
		if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

		let contents = this.state.loading ? this.renderLoading() :
			[
				this.state.lockScreen === 1 && this.lockScreen(),
				<Header data={this.state.data} />,
				this.renderForm(),
				this.renderPopupComponent(),
				<Footer />
			];

		return contents;
	}
}